import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import {
    Link, useNavigate,
} from "react-router-dom";
import MTable from '../../Components/MTable/MTable';
import Overlay from '../../Components/Overlay';
import { NumberFormat } from '../../Components/NumberFormat';
import moment from 'moment';
import { getListProduk } from '../../Service/SalesService';
import MSelect from '../../Components/MSelect';
import Swal from 'sweetalert2';
import { createGoodIssue, getProductQty, getToWarehouses } from '../../Service/InventoryService';
import { empty_data } from '../../Images';

let processingId = -1;
const { $, setupDigitInput } = window;
const TransferForm = () => {
    const navigate = useNavigate();
    let { userInfo } = useSelector(state => state.auth);
    const { user_id, user_warehouse_stock, warehouse_stock_name, user_warehouse_display, warehouse_display_name, user_warehouse_indent, warehouse_indent_name } = userInfo;
    const mTableP = useRef();
    const options = [
        { value: user_warehouse_stock, label: warehouse_stock_name },
        { value: user_warehouse_display, label: warehouse_display_name },
        { value: user_warehouse_indent, label: warehouse_indent_name }
    ]
    const [state, setStates] = useState({
        processing: false,
        showProduct: false,
        delivery_date: moment().format('YYYY-MM-DD'),
        products: [],
        from: '',
        to: '',
        consignee: '',
        selectedProduct: {
            itemname: '',
            itemno: '',
            price: 0,
            qty: 1,
            onhand: 0
        },
        toWarehouses: [],
        errors: {
            from: '',
            to: '',
            consignee: '',
            products: ''
        },
        processing: false
    });

    const setState = value => {
        setStates({ ...state, ...value });
    }

    useEffect(() => {
        getToWarehouses(res => {
            const _toWarehouses = res.data.data.map(item => ({
                value: item.WhsCode,
                label: item.WhsName
            }));
            setState({ toWarehouses: _toWarehouses });
        });
    }, []);

    const onAddData = () => {
        onReset();

    }

    const onReset = () => {
        setState({
            from: '',
            to: '',
            consignee: '',
            products: [],
            errors: {
                from: '',
                to: '',
                consignee: '',
                products: ''
            }
        });
    }

    const onSelectProduct = item => () => {
        const payload = [
            { ItemCode: item.ItemCode, WhsCode: state.from }
        ];
        getProductQty(payload, res => {
            const [inv] = res.data;
            const qty = parseInt(0 + inv.OnHand);
            item.Onhand = qty;
            setState({
                showProduct: true,
                selectedProduct: {
                    itemname: item.ItemName,
                    itemno: item.ItemCode,
                    price: item.Price,
                    qty: 1,
                    onhand: qty
                }
            });
        })


    };

    const addProductDetail = () => {
        const index = products.findIndex(e => e.itemno == selectedProduct.itemno);
        if (index > -1) {
            products[index].itemname = selectedProduct.itemname;
            products[index].itemno = selectedProduct.itemno;
            products[index].price = selectedProduct.price;
            products[index].qty = selectedProduct.qty;
        } else {
            products.push({
                itemname: selectedProduct.itemname,
                itemno: selectedProduct.itemno,
                price: selectedProduct.price,
                qty: selectedProduct.qty,
                onHand: selectedProduct.onhand
            });
        }
        setState({
            products
        });
        $("#modal-product").modal('hide');
        setupDigitInput();
    }
    const onReduceQty = () => {
        let min = state.selectedProduct.qty - 1;
        if (min < 1) {
            return;
        }
        const _selectedProduct = { ...state.selectedProduct, qty: min };
        setState({ selectedProduct: _selectedProduct });

    }
    const onAddQty = () => {
        let pls = state.selectedProduct.qty + 1;
        if (pls > selectedProduct.onhand) {
            return;
        }
        const _selectedProduct = { ...state.selectedProduct, qty: pls };
        setState({ selectedProduct: _selectedProduct });
    }

    const columns_product = [
        {
            id: 1, title: 'Item Description', field: 'ItemName', sortable: true,
            render: item => {
                return (
                    <a
                        onClick={onSelectProduct(item)}
                        style={{
                            cursor: 'pointer',
                            fontWeight: '500'
                        }}
                    >
                        {item.ItemName}
                    </a>
                )
            }
        },
        { id: 2, title: 'Model', field: 'U_SOL_EX_MODEL', sortable: true },
        { id: 3, title: 'Price/Unit', field: 'Price',  render: item => {
            return NumberFormat(item.Price)
        }},
        { id: 3, title: 'Net Disc', field: 'BuyUnitMsr' },

    ];
    const addProduct = () => {
        mTableP.current.reset();
        setState({
            showProduct: false,
            selectedProduct: {
                itemname: '',
                itemno: '',
                price: '',
                qty: 1,
                onhand: 0
            }
        });
        $("#modal-product").modal();
    }

    const setChangeFrom = (e) => {
        setState({ from: e.value, errors: { ...errors, from: '' } });
    }

    const setChangeTo = (e) => {
        setState({ to: e.value, errors: { ...errors, to: '' } });
    }

    const onConsigneeChange = e => {
        setState({ consignee: e.target.value, errors: { ...errors, consignee: '' } })
    }

    const onQtyChange = e => {
        console.log(' Qty Changed!');
    }

    const onRemoveProductClick = item => () => {
        const _products = products.filter(x => x.itemno != item.itemno);
        setState({ products: _products });
    }

    const onProductQtyChange = item => e => {
        if (item.onHand < e.target.value) {
            return;
        }
        const index = products.findIndex(e => e.itemno == item.itemno);
        item.qty = e.target.value;
        if (item.qty < 1) {
            item.qty = 1;
        }
        products[index] = item;
        setState({ products });
    }

    const onSubmitTransfer = () => {
        const { user_id, AcctCode, BPLName, BPLId } = userInfo;
        const fromName = options.find(e => e.value == from)?.label;
        const toName = toWarehouses.find(e => e.value == to)?.label;
        const payload = {
            consignee,
            bplid: BPLId,
            bplname: BPLName,
            fromwhscode: from,
            fromwhsname: fromName,
            towhscode: to,
            towhsname: toName,
            created_by: user_id,
            line_items: products.map(e => ({
                whscode: from,
                whsname: fromName,
                accountcode: AcctCode,
                itemcode: e.itemno,
                dscription: e.itemname,
                qty: e.qty
            }))
        };

        if (validate(payload)) {
            
            setState({ processing: true });
            createGoodIssue(payload, res => {
                const { data } = res.data;
                const { docnum } = data;
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Create stock transfer success with Document Number: ' + docnum
                }).then(res => {
                    navigate('/inventorytransfer');
                });
            }, ({ response }) => {
                const { message } = response?.data;
                Swal.fire({
                    icon: 'error',
                    title: 'Create stock transfer Error',
                    text: message
                });
                console.log('Create stock transfer error', response);
            }).finally(() => {
                setState({ processing: false });
            });
        }
    }

    const validate = (payload) => {
        const { bplid, bplname, fromwhscode, towhscode, consignee, created_by } = payload;
        let message = '';
        if (!created_by) {
            message = 'User iD of this user is not found!';
        } else if (!bplid) {
            message = 'BPLId of this user is not found!';
        } else if (!bplname) {
            message = 'BPLName of this user is not found!';
        } else if (!fromwhscode) {
            message = 'From warhouse is required';
            setState({ errors: { ...errors, from: message } });
            return false;
        } else if (!towhscode) {
            message = 'To warhouse is required';
            setState({ errors: { ...errors, to: message } });
            return false;
        } else if (products.length == 0) {
            message = 'Products is required!';
        } else if (!consignee) {
            message = 'Consignee is required!';
            setState({ errors: { ...errors, consignee: message } });
            return false;
        } else if(fromwhscode == towhscode) {
            message = 'From warehouse and To Warehouse should not be the same';
            setState({ errors: { ...errors, from: message } });
            return false;
        }else {
            return true;
        }

        if (message) {
            Swal.fire({
                title: 'Invalid Data',
                text: message,
                icon: 'error'
            });
            return false;
        }
    }

    const propsTable = { columns: columns_product, getData: getListProduk, showIndex: true, perpage: 5 };
    const { products, toWarehouses, from, to, consignee: consignee, selectedProduct, errors, processing, delivery_date } = state;

    return (
        <div className="content-wrapper">

            <Overlay display={processing} />
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h2 className="title-breadcrum">Transfer</h2>
                            <p>Date {moment(delivery_date).format('DD MMM YYYY')}</p>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 bg-white">
                            <h6 className="m-0 title-breadcrum tx-gray" >
                                Warehouse
                            </h6>
                        </div>
                        <div className="card-body" >
                            <div className="row" style={{ margin: '0 40px' }}>
                                <div className="col-md-4" >
                                    <MSelect label='From Warehouse' options={options} value={state.from} onChange={setChangeFrom} error={errors.from} />

                                </div>
                                <div className="col-md-4">
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 100 }}>
                                        <div style={{ width: '100%', height: 2, borderBottom: 'dotted 2px #aaa' }} />
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <MSelect label='To Warehouse' options={toWarehouses}
                                        value={state.to} onChange={setChangeTo} error={errors.to} />
                                </div>
                            </div>
                            <div className="row mb-4" style={{ margin: '0 40px' }}>
                                <div className="col-md-4">
                                    <div className="">
                                        <label>Consignee</label>
                                        <input type="text" name="consignee" value={consignee} onChange={onConsigneeChange} className="form-control" />
                                        <span className='text-danger' style={{ fontSize: 10 }}>{errors.consignee}</span>
                                    </div>
                                </div>
                            </div>



                            <div id="modal-product" className='modal fade'>
                                <form name="form-product">
                                    <div className='modal-dialog modal-dialog-centered modal-xl'>
                                        <div className='modal-content'>
                                            <div className='modal-header'>
                                                <h5 className="modal-title"> Product List</h5>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                            </div>
                                            <div className='modal-body'>
                                                <div className="row">
                                                    <div className='col-sm-8'>
                                                        <MTable ref={mTableP} {...propsTable} />
                                                    </div>
                                                    <div className='col-sm-4'>
                                                        <div className="card">
                                                            <div className="card-header card-header-product">Detail Product</div>
                                                            <div className="card-body" style={{ minHeight: 250 }}>
                                                                {!state.showProduct ?
                                                                    <div>
                                                                        <div className="row h-100 justify-content-center align-items-center">
                                                                            <i className="bi bi-x-circle-fill" style={{ fontSize: 50 }}></i>
                                                                        </div>
                                                                        <br />
                                                                        <p style={{ textAlign: 'center' }}>Product not found!  <br />Please Select Product</p>
                                                                    </div>
                                                                    :
                                                                    <div>
                                                                        <div className='row h-100 justify-content-center align-items-center'>
                                                                            <p>{state.selectedProduct.itemname} ({state.selectedProduct.itemno})</p>
                                                                            <div className='col-sm-4'>
                                                                                <div className="form-check form-check-inline" style={{ textAlign: 'center', paddingLeft: 0, display: 'block' }}>
                                                                                    <label className="form-check-label" htmlFor="inlineRadio1">Ready</label>
                                                                                    <span className='angka-stock'>{selectedProduct.onhand}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='row d-flex justify-content-center' style={{ marginTop: 30 }}>
                                                                            <div style={{ width: 150 }}>
                                                                                <div className="qty-box" style={{ textAlign: 'center', position: 'relative' }}>
                                                                                    <span className="minus-box bg-dark" onClick={onReduceQty} style={{ position: 'absolute', top: 5, left: 7 }}>-</span>
                                                                                    <input type="number" className="input-qty counter" style={{ border: 'solid 0px #ccc' }} value={state.selectedProduct.qty} onChange={onQtyChange} />
                                                                                    <span className="plus-box bg-dark" onClick={onAddQty} style={{ position: 'absolute', top: 5, right: 0 }}>+</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='row h-100 justify-content-center align-items-center mt-4'>
                                                                            <button className="btn btn-dark" type="button" onClick={() => addProductDetail()} disabled={selectedProduct.qty > selectedProduct.onhand}>
                                                                                <span className='fas fa-plus'></span> Add Product
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    {products && products.length > 0 &&
                        <>
                            <div className="card shadow mb-4">
                                <div className="card-header py-3 bg-white">
                                    <div className='row'>
                                        <div className='col-sm-8'>
                                            <h6 className="m-0 title-breadcrum tx-gray" >Detail Product</h6>
                                        </div>

                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-hover" id="dataTable" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th className='th-no-border'></th>
                                                    <th className='th-no-border'>No</th>
                                                    <th className='th-no-border'>Product</th>
                                                    <th className='th-no-border'>OnHand</th>
                                                    <th className='th-no-border' style={{ width: 100, textAlign: 'center' }}>Qty</th>
                                                    {/* <th className='th-no-border'></th> */}
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {state.products.map((item, index) => (
                                                    <tr key={`tr-` + index} >
                                                        <td>
                                                            <button className="btn btn-sm" onClick={onRemoveProductClick(item)} style={{ marginTop: -2 }} type='button'><i className="fa fa-trash text-danger"></i></button>
                                                        </td>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            {`${item.itemname} (${item.itemno})`}
                                                        </td>
                                                        <td>{item.onHand}</td>
                                                        <td>
                                                            <input className="form-control ps-0 text-right digit" type="text" value={item.qty} onChange={onProductQtyChange(item)} />
                                                        </td>
                                                        {/* <td>
                                                            <div>
                                                                <button className="btn btn-outline-warning"
                                                                    style={{ border: 'dotted', marginBottom: 10, width: 100 }} type="button">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-qr-code-scan" viewBox="0 0 16 16">
                                                                        <path d="M0 .5A.5.5 0 0 1 .5 0h3a.5.5 0 0 1 0 1H1v2.5a.5.5 0 0 1-1 0v-3Zm12 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V1h-2.5a.5.5 0 0 1-.5-.5ZM.5 12a.5.5 0 0 1 .5.5V15h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5Zm15 0a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H15v-2.5a.5.5 0 0 1 .5-.5ZM4 4h1v1H4V4Z" />
                                                                        <path d="M7 2H2v5h5V2ZM3 3h3v3H3V3Zm2 8H4v1h1v-1Z" />
                                                                        <path d="M7 9H2v5h5V9Zm-4 1h3v3H3v-3Zm8-6h1v1h-1V4Z" />
                                                                        <path d="M9 2h5v5H9V2Zm1 1v3h3V3h-3ZM8 8v2h1v1H8v1h2v-2h1v2h1v-1h2v-1h-3V8H8Zm2 2H9V9h1v1Zm4 2h-1v1h-2v1h3v-2Zm-4 2v-1H8v1h2Z" />
                                                                        <path d="M12 9h2V8h-2v1Z" />
                                                                    </svg>&nbsp;Scan
                                                                </button>
                                                            </div>
                                                        </td> */}

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>

                                    </div>
                                    <div className='row d-flex align-items-center justify-content-center' style={{ marginBottom: 30 }}>
                                        <button onClick={addProduct} className="btn btn-outline-primary" style={{ border: 'none', width: 200 }} type="button">
                                            <span className='fas fa-plus'></span> Add Product
                                        </button>
                                    </div>
                                    <div className='row' style={{ marginBottom: 50 }}>
                                        <div className='col-sm-7'>

                                        </div>
                                        <div className='col-sm-5'>

                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className='row' style={{ justifyContent: 'flex-end' }}>
                                <div className='col-sm-2'>
                                    <Link to="/" className='btn btn-readonly btn-block' style={{ marginBottom: 30 }}>Cancel</Link>
                                </div>
                                <div className='col-sm-2'>
                                    <button className="btn btn-modena btn-block" style={{ marginBottom: 30 }} type="button" onClick={onSubmitTransfer}>
                                        Transfer
                                    </button>
                                </div>

                            </div>
                        </>
                    }
                    {state.products.length <= 0 &&
                        <div className='row d-block'>
                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className='row d-flex align-items-center justify-content-center'>
                                        <img src={empty_data} />
                                    </div>
                                    <div className='row d-flex align-items-center justify-content-center mb-5'>
                                        <button className="btn btn-dark" type="button" onClick={addProduct}>
                                            <span className='fas fa-plus'></span> Add Product
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </section>
        </div>
    );

};

export default TransferForm;
